<template>
  <base-rounded-button
    size="x-small"
    @click="getPdf"
    :tooltip="$i18n.t('default.generatePdf')"
    icon="mdi-printer"
    color="rgba(235, 235, 235, 0.5)"
    iconColor="#202124"
    :loading="loading"
  />
</template>
<script>
import { get } from 'vuex-pathify';
import pdfCard from '@/mixins/pdfCard';
import prepareAttributesFeatureCardMixin from '@/mixins/prepareAttributesFeatureCardMixin';

export default {
  name: 'FeatureCardPdf',
  mixins: [pdfCard, prepareAttributesFeatureCardMixin],
  props: {
    featureProperties: {
      type: Object,
      default: () => {
        return {};
      },
    },
    featureId: {
      type: [Number, String],
      default: null,
    },
    formSchema: {
      type: Array,
      required: true,
    },
    layer: {
      type: Object,
      required: true,
    },
  },
  computed: {
    users: get('users/users'),
    descAttributeName() {
      return this.metadata[this.layer?.data_source_name]?.attributes_schema.desc_attribute_name;
    },
  },
  data: () => ({
    loading: false,
    logoUrl: `${process.env.VUE_APP_API_URL}/settings/logo`,
  }),
  methods: {
    getPdf() {
      const featureUrl = `${process.env.VUE_APP_HOST}/map/layers/${this.layer.id}/${this.featureId}`;
      const attributes = this.formSchema.map(gElement => {
        return {
          name: gElement.label,
          elements: gElement.elements.map(aElement => {
            return {
              name: aElement.unit ? `${aElement.label} [${aElement.unit}]` : aElement.label,
              value: this.getAttributeTextValue(this.featureProperties, aElement),
            };
          }),
        };
      });
      const lastChangeUserId = this.featureProperties.update_user;
      const lastChangeDate = this.featureProperties.update_datetime;
      const firstChangeUserId = this.featureProperties.create_user;
      const firstChangeDate = this.featureProperties.create_datetime;
      const config = {
        layerName: this.layer.name,
        featureId: this.featureProperties[this.descAttributeName],
        lastChangeDate: lastChangeDate ? this.$dayjs(lastChangeDate).format('L LT') : '',
        lastChangeUserName: lastChangeUserId ? this.users[lastChangeUserId]?.name : null,
        firstChangeDate: firstChangeDate ? this.$dayjs(firstChangeDate).format('L LT') : '',
        firstChangeUserName: firstChangeUserId ? this.users[firstChangeUserId]?.name : null,
        logoUrl: this.logoUrl,
        featureUrl,
        attributes,
      };
      this.generatePdf(config);
    },
  },
};
</script>
